export default {
  orgId: (state, getters) => getters['orgs/orgId'],
  userId: (state, getters) => getters['users/userId'],
};



// WEBPACK FOOTER //
// ./src/store/getters.js